<template>
    <div class="schedules-container">
        <div class="schedules__sidebar">
            <ChannelSelector/>
            <ContentsFinder/>
        </div>
    </div>
</template>

<script>
import ChannelSelector from '@/components/cms/common/Schedule/SideBar/ChannelSelector';
import ContentsFinder from '@/components/cms/common/Schedule/SideBar/ContentsFinder';

export default {
    name: 'SchedulesSideBar',
    components: {
        ChannelSelector,
        ContentsFinder,
    },
};
</script>
